namespace RioERP.Carts {
    export interface CartProductBillingItemsForm {
        CartId: Serenity.IntegerEditor;
        CartProductsId: Serenity.IntegerEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxCategoryId: Serenity.IntegerEditor;
        ProductBillingItemId: Serenity.IntegerEditor;
        InvoiceCompanyId: Serenity.IntegerEditor;
        IsActive: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
    }

    export class CartProductBillingItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.CartProductBillingItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CartProductBillingItemsForm.init)  {
                CartProductBillingItemsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.DateEditor;

                Q.initFormType(CartProductBillingItemsForm, [
                    'CartId', w0,
                    'CartProductsId', w0,
                    'GrossAmount', w1,
                    'DiscountAmount', w1,
                    'NetAmount', w1,
                    'TaxableAmount', w1,
                    'TaxCategoryId', w0,
                    'ProductBillingItemId', w0,
                    'InvoiceCompanyId', w0,
                    'IsActive', w2,
                    'InsertUserId', w0,
                    'InsertDate', w3,
                    'UpdateUserId', w0,
                    'UpdateDate', w3
                ]);
            }
        }
    }
}
